import { Typography } from 'antd';
import { getUomTypesAbbreviations } from './constants';
import { useGetBasicUomEnum } from 'hooks';
import { parseNumber } from 'utils/parser';
import SeparatorBar from 'pages/product-full-view/components/product-media-area/nutrition-label/components/SeparatorBar';
import { DAILY_VALUE_OPERATOR, MEASUREMENT_OPERATOR } from './Constant';
import { NUTRIENTS_DATA } from '../../../product-full-view/components/product-media-area/nutrition-label/constants';

function NutrientRowNew({ nutrient, labelItalic }) {
  const {
    dailyValueIntakePercent,
    percentBold,
    indentBar,
    indent,
    labelBold,
    quantity,
    quantityUom,
    bottomBar,
    nutritionName,
    bottomBarHeight,
    topBarHeight,
    topBar,
    hightLightText,
    measurementPrecisionCode,
    dailyValuePrecisionCode,
  } = nutrient ?? {};

  const { basicUomProperties } = useGetBasicUomEnum();

  const showAbbr = (quantityUom, defaultUom = 'g') => {
    return (
      getUomTypesAbbreviations(basicUomProperties, quantityUom) ?? defaultUom
    );
  };

  const percent = parseNumber(dailyValueIntakePercent);

  const gram =
    parseNumber(quantity) !== ''
      ? `${parseNumber(quantity)}${showAbbr(quantityUom, 'g')}`
      : null;

  const indentLabel = indent ? `${indent}px` : '0';
  const labelWeight = labelBold ? 900 : 400;
  const percentWeight = percentBold ? 900 : 400;
  const indentDiv = indentBar ? `${indentBar}px` : indentLabel;

  const styles = {
    div: {
      display: 'flex',
      justifyContent: 'space-between',
      marginLeft: indentDiv,
    },
    label: {
      fontWeight: labelWeight,
      fontStyle: labelItalic ? 'italic' : '',
    },
    percent: {
      fontWeight: percentWeight,
    },
    gram: {
      paddingLeft: '2px',
      paddingRight: '5px',
    },
    measurementPrecision: {
      paddingLeft: '2px',
      paddingRight: '1px',
      fontWeight: 400,
    },
    indent: {
      backgroundColor: hightLightText,
    },
  };

  const renderSymbols = (measurementPrecisionCode) => {
    return MEASUREMENT_OPERATOR?.[measurementPrecisionCode] || '';
  };

  const renderDailyValueSymbols = (dailyValuePrecisionCode) => {
    return DAILY_VALUE_OPERATOR?.[dailyValuePrecisionCode] || '';
  };

  const measurementPrecision = renderSymbols(measurementPrecisionCode);
  const dailyValuePrecision = renderDailyValueSymbols(dailyValuePrecisionCode);

  const nutrientArray = NUTRIENTS_DATA.find(
    (item) => item.enumValue === nutritionName
  );

  const updatedLabel = nutrientArray
    ? nutrientArray.enumDisplayName
    : nutritionName;

  return (
    <div className='nutrition-facts__nutrition-row' style={styles.indent}>
      {topBar ? null : (
        <SeparatorBar indentBar={indentBar || 0} height={topBarHeight || 0} />
      )}
      <div style={styles.div}>
        <div className='nutrition-facts__nutrition-row_name'>
          <div style={styles.label}>{updatedLabel}</div>
          {gram ? (
            <>
              <div style={styles.measurementPrecision}>
                {measurementPrecision}
              </div>
              <div style={styles.gram}>{gram}</div>
            </>
          ) : null}
        </div>
        <div style={styles.percent}>
          {percent === 0 || percent > 0 ? (
            <div style={styles.measurementPrecision}>
              <Typography.Text style={{ fontWeight: 400, paddingRight: 4 }}>
                {dailyValuePrecision}
              </Typography.Text>
              {percent}%
            </div>
          ) : null}
        </div>
      </div>

      {bottomBar && (
        <SeparatorBar
          indentBar={indentBar || 0}
          height={bottomBarHeight || 0}
        />
      )}
    </div>
  );
}

export default NutrientRowNew;
